import React from 'react';
import { Card, Tag, Typography, Button, Space } from 'antd';
import { RightOutlined, CheckCircleOutlined, ClockCircleOutlined, StopOutlined } from '@ant-design/icons';

const { Text } = Typography;

// Contrato de GET /api/professor/encontros (Fase 11-B): id, turma_id,
// equipe_id, data, hora_inicio, hora_fim, status, chamada_fechada_em,
// chamada_fechada_por, nome_turm, modalidade_nome. nome_turm/modalidade_nome
// ja vem prontos do backend (Turma/Turma.modalidade via selectinload) --
// este card NAO concatena os dois em uma unica string nem inventa nada;
// exibe os dois campos independentes, em hierarquia visual distinta.

const STATUS_INFO = {
  PREVISTA: {
    label: 'Chamada pendente',
    color: 'gold',
    icon: <ClockCircleOutlined />,
  },
  REALIZADA: {
    label: 'Chamada realizada',
    color: 'green',
    icon: <CheckCircleOutlined />,
  },
  CANCELADA: {
    label: 'Aula cancelada',
    color: 'default',
    icon: <StopOutlined />,
  },
};

const formatarHora = (valor) => {
  if (!valor) return '--:--';
  // Backend retorna "HH:MM:SS" (time do Python serializado pelo Pydantic).
  return valor.slice(0, 5);
};

const EncontroCard = ({ encontro, onAbrirChamada }) => {
  const statusInfo = STATUS_INFO[encontro.status] || {
    label: encontro.status,
    color: 'default',
    icon: null,
  };
  const cancelada = encontro.status === 'CANCELADA';

  return (
    <Card className="portal-professor__card" data-testid="encontro-card">
      <div className="portal-professor__card-row">
        <Space direction="vertical" size={2} style={{ minWidth: 0, flex: '1 1 auto' }}>
          <Text strong style={{ fontSize: 16, lineHeight: 1.3, wordBreak: 'break-word' }}>
            {encontro.nome_turm}
          </Text>
          <Text type="secondary" style={{ fontSize: 13, wordBreak: 'break-word' }}>
            {encontro.modalidade_nome}
          </Text>
          <Text type="secondary" style={{ fontSize: 13 }}>
            {formatarHora(encontro.hora_inicio)} — {formatarHora(encontro.hora_fim)}
          </Text>
          <Tag icon={statusInfo.icon} color={statusInfo.color} aria-label={`Status: ${statusInfo.label}`}>
            {statusInfo.label}
          </Tag>
        </Space>

        <Button
          className="portal-professor__card-action"
          type={cancelada ? 'default' : 'primary'}
          disabled={cancelada}
          aria-label={cancelada ? 'Aula cancelada, chamada indisponível' : `Abrir chamada de ${encontro.nome_turm}`}
          onClick={() => onAbrirChamada(encontro)}
          icon={<RightOutlined />}
          iconPosition="end"
        >
          {cancelada ? 'Indisponível' : 'Abrir chamada'}
        </Button>
      </div>
    </Card>
  );
};

export default EncontroCard;
